import "./Navbar.css";
import logo from "../../assets/logo/logo.png";

import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { FiLogIn } from "react-icons/fi";
import { FaShoppingBag } from "react-icons/fa";

import { HiOutlineMenuAlt3, HiX, HiChevronDown } from "react-icons/hi";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const [mobileCollectionsOpen, setMobileCollectionsOpen] = useState(false);

  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  // const API_BASE_URL = (
  //   process.env.REACT_APP_API_BASE_URL || "http://localhost:5080/api"
  // ).replace(/\/+$/, "");

  const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL || "https://yadnya.azurewebsites.net/api"
  ).replace(/\/+$/, "");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/categories`, {
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch categories: ${response.status}`);
        }

        const data = await response.json();

        const categoryList = Array.isArray(data)
          ? data
          : data.categories || data.data || data.items || [];

        const formattedCategories = categoryList
          .map((category) => {
            const name =
              typeof category === "string"
                ? category
                : category.name ||
                  category.categoryName ||
                  category.displayName ||
                  category.category ||
                  "";

            const slug =
              typeof category === "object"
                ? category.slug ||
                  category.categorySlug ||
                  String(name).toLowerCase().trim().replace(/\s+/g, "-")
                : String(name).toLowerCase().trim().replace(/\s+/g, "-");

            return {
              id: category.id ?? category.categoryId ?? slug,
              name,
              slug,
            };
          })
          .filter((category) => category.name && category.slug);

        setCategories(formattedCategories);
      } catch (error) {
        console.error("Error loading navbar categories:", error);
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);

    setMobileCollectionsOpen(false);
  }, [location]);

  // Disable background scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const closeMenu = () => {
    setMenuOpen(false);

    setMobileCollectionsOpen(false);
  };

  return (
    <>
      {/* TOP BAR */}

      <div className="top-bar">
        ✨ Free Shipping on Orders Above ₹5000 &nbsp; | &nbsp; Authentic
        Handloom Sarees
      </div>

      {/* NAVBAR */}

      <header className="navbar">
        <div className="container nav-container">
          {/* LOGO */}

          <Link to="/" className="logo" onClick={closeMenu}>
            <img src={logo} alt="Yadnya Handloom" />
          </Link>

          {/* MENU */}

          <nav className={menuOpen ? "nav-links active" : "nav-links"}>
            {/* HOME */}

            <Link
              to="/"
              className={location.pathname === "/" ? "active" : ""}
              onClick={closeMenu}
            >
              Home
            </Link>

            {/* COLLECTIONS */}

            <div className="dropdown">
              <div className="dropdown-heading">
                <Link
                  to="/shop"
                  className={
                    location.pathname.startsWith("/shop") ? "active" : ""
                  }
                  onClick={(e) => {
                    // Mobile: only arrow opens dropdown

                    if (window.innerWidth <= 991) {
                      e.preventDefault();
                    } else {
                      closeMenu();
                    }
                  }}
                >
                  Collections
                </Link>

                <button
                  className="mobile-arrow"
                  onClick={(e) => {
                    e.preventDefault();

                    e.stopPropagation();

                    setMobileCollectionsOpen(!mobileCollectionsOpen);
                  }}
                >
                  <HiChevronDown
                    className={mobileCollectionsOpen ? "rotate" : ""}
                  />
                </button>
              </div>

              {/* DROPDOWN ITEMS */}

              {/* <div
                className={
                  mobileCollectionsOpen ? "dropdown-menu open" : "dropdown-menu"
                }
              >
                <Link to="/shop/cotton-paithani" onClick={closeMenu}>
                  Cotton Paithani
                </Link>

                <Link to="/shop/pure-silk-paithani" onClick={closeMenu}>
                  Pure Silk Paithani
                </Link>

                <Link to="/shop/munia-paithani" onClick={closeMenu}>
                  Munia Paithani
                </Link>

                <Link to="/shop/cotton-ilkal" onClick={closeMenu}>
                  Cotton Ilkal
                </Link>

                <Link to="/shop/pure-silk-ilkal" onClick={closeMenu}>
                  Pure Silk Ilkal
                </Link>

                <Link to="/shop/maheshwari" onClick={closeMenu}>
                  Maheshwari
                </Link>

                <Link to="/shop/chanderi" onClick={closeMenu}>
                  Chanderi
                </Link>

                <Link to="/shop/shivreva" onClick={closeMenu}>
                  Shivreva Pastel
                </Link>

                <Link to="/shop/sambalpuri" onClick={closeMenu}>
                  Sambalpuri
                </Link>
                <Link to="/shop/banarasi" onClick={closeMenu}>
                  Banarasi Saree
                </Link>
              </div> */}

              <div
                className={
                  mobileCollectionsOpen ? "dropdown-menu open" : "dropdown-menu"
                }
              >
                {categoriesLoading ? (
                  <span className="dropdown-message">
                    Loading categories...
                  </span>
                ) : categories.length > 0 ? (
                  categories.map((category) => (
                    <Link
                      key={category.id}
                      to={`/shop/${category.slug}`}
                      onClick={closeMenu}
                      className={
                        location.pathname === `/shop/${category.slug}`
                          ? "active"
                          : ""
                      }
                    >
                      {category.name}
                    </Link>
                  ))
                ) : (
                  <span className="dropdown-message">
                    No categories available
                  </span>
                )}
              </div>
            </div>

            {/* NEW ARRIVALS */}

            <Link
              to="/shop?filter=new"
              className={
                location.pathname === "/shop" &&
                location.search === "?filter=new"
                  ? "active"
                  : ""
              }
              onClick={closeMenu}
            >
              New Arrivals
            </Link>

            {/* OUR STORY */}

            <Link
              to="/our-story"
              className={location.pathname === "/our-story" ? "active" : ""}
              onClick={closeMenu}
            >
              Our Story
            </Link>

            {/* CONTACT */}

            <Link
              to="/contact"
              className={location.pathname === "/contact" ? "active" : ""}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </nav>

          {/* ICONS */}

          {/* <div className="nav-icons">
            <FaShoppingBag />

            <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <HiX /> : <HiOutlineMenuAlt3 />}
            </button>
          </div> */}
          {/* ICONS */}

          <div className="nav-icons">
            <FaShoppingBag />

            <Link
              to="/admin/login"
              className="admin-login-nav-btn"
              onClick={closeMenu}
            >
              <FiLogIn />
              <span>Admin Login</span>
            </Link>

            <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <HiX /> : <HiOutlineMenuAlt3 />}
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE OVERLAY */}

      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </>
  );
};

export default Navbar;
